export const TOURNAMENT_LOAD_STARTLISTS = 'TOURNAMENT_LOAD_STARTLISTS'
export const TOURNAMENT_LOAD_STARTLISTS_SUCCESS = 'TOURNAMENT_LOAD_STARTLISTS_SUCCESS'
export const TOURNAMENT_LOAD_STARTLISTS_FAILURE = 'TOURNAMENT_LOAD_STARTLISTS_FAILURE'
